"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ol = require("openlayers");
const sources_1 = require("./sources");
function createLayers(selectionLayer) {
    const sources = sources_1.createSources();
    const layers = Object.keys(sources)
        .map(name => new ol.layer.Tile({
        visible: false,
        preload: Infinity,
        source: sources[name]
    })).concat([new ol.layer.Vector({
            source: selectionLayer,
            style: new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(255, 0, 0, 0.2)'
                }),
                stroke: new ol.style.Stroke({
                    color: 'red',
                    width: 2
                })
            })
        })]);
    layers[0].setVisible(true);
    return layers;
}
exports.createLayers = createLayers;



//////////////////
// WEBPACK FOOTER
// ./src/map/layers.ts
// module id = 311
// module chunks = 0